module.exports = __webpack_public_path__ + "static/media/back2.56951e0b.png";